export type SemVer = [number, number, number?, string?]

export function parse(version: string): SemVer {
  const match = version.match(/^(\d+)\.(\d+)(?:\.(\d+))?(.*)$/)
  if (!match) {
    throw new Error(`invalid version format: ${version}`)
  }
  return [Number(match[1]), Number(match[2]), Number(match[3]) || 0, match[4]]
}

export function lt(a: SemVer, b: SemVer): boolean {
  if (a[0] !== b[0]) return a[0] < b[0]
  if (a[1] !== b[1]) return a[1] < b[1]
  if (a[2] !== b[2]) return (a[2] || 0) < (b[2] || 0)
  return false
}
